import React, { useState, useContext, useEffect } from "react"
import { Link } from "gatsby"
import { UserContext } from './../../utils/usermanagement'
import { ChildAPIContext } from './../../utils/childapi'
import AccountPanel from "./../../components/AccountPanel/AccountPanel";
import Logo from '../../images/EE-logo.png'
import "./Navigation.scss"



const Navigation = (props) => {
	const [userState, userDispatch] = useContext(UserContext);
	const childAPIData = useContext(ChildAPIContext)
	const [isLoggedIn, setisLoggedIn] = useState(false);
	const [hoverClass, setHover] = useState(null);

	const isPartiallyActive = ({ isPartiallyCurrent }) => {
		return isPartiallyCurrent ? { className: "nav-link link active" } : {}
	}
	const removeHover = (e) => {
		setHover('')
	}

	const addHover = (e) => {
		setHover('bg--hover')
	}

	useEffect(() => {
		if (userState?.cognito_user?.attributes) {
			setisLoggedIn(true)
		} else {
			setisLoggedIn(false)
		}
	}, [userState])

	const pageTitle = props.pageTitle;

	const dataLayerClickHandler = (element) => {
		let linkUrl = element.currentTarget.href,
		  clickText = element.currentTarget.innerText,
		  rollType = "anonymous",
		  loginStatus = "logged-out",
		  isLogoClicked = element.currentTarget.parentElement?.className === "logo";
	
		if (childAPIData?.childAPI && childAPIData?.childAPI[0]?.auth_token) {
		  rollType = "kids";
		  loginStatus = "logged-in";
		} else if (userState && userState?.cognito_user?.username) {
		  rollType = "parent";
		  loginStatus = "logged-in";
		}
	
		let analyticsObj = {
		  event: "Navigation_interaction",
		  loginStatus: loginStatus,
		  actionType: isLogoClicked ? "Logo Click" : "Header Link Click",
		  clickText: isLogoClicked ? "EEPhoneSmart Logo" : clickText,
		  linkType: "internal",
		  linkUrl: linkUrl,
		  moduleName: "Navigation",
		  pageName: pageTitle,
		  inPageLocation: "top",
		  userType: rollType,
		};
	
		window.dataLayer.push(analyticsObj);
	};

	return (
		<nav id="mainNav" className={`navbar navbar-expand-md bg--split ${hoverClass}`}>
			<div className="container-fluid container-md  bg--inner p-0">
				<div className="nav-wrapper">
					<button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"></span>
					</button>
					<div className="logo">
						<Link to={`/`} onClick={(e) => dataLayerClickHandler(e)}>
							<img src={Logo} alt="EEPhonesmart" />
						</Link>
					</div>
					<div className="collapse navbar-collapse" id="navbarSupportedContent">
						<div className="nav-wrapper menu-items">
							<button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
								<span className="navbar-toggler-icon"></span>
							</button>
							<div className="logo">
								<Link to={`/`} onClick={(e) => dataLayerClickHandler(e)}>
									<img src={Logo} alt="EEPhonesmart" />
								</Link>
							</div>
						</div>

						<ul className="main-nav navbar-nav ">
							<li className="nav-item">
								{
									isLoggedIn ?
										<Link to={`/dashboard/`} getProps={isPartiallyActive} className="nav-link link" onClick={(e) => dataLayerClickHandler(e)}>
											Dashboard<span>&gt;</span>
										</Link>
										:
										<Link to={`/dashboard/`} getProps={isPartiallyActive} className="nav-link link disabled" tabIndex="-1" aria-disabled="true">Dashboard<span>&gt;</span></Link>
								}
							</li>
							<li className="nav-item border-left">
								<Link to={`/online-safety-tips/`} getProps={isPartiallyActive} className="nav-link link" onClick={(e) => dataLayerClickHandler(e)}>
									Advice &amp; Tips<span>&gt;</span>
								</Link>
							</li>
							<li className="nav-item border-left">
								<Link to={`/about/`} getProps={isPartiallyActive} className="nav-link link" onClick={(e) => dataLayerClickHandler(e)}>
									About PhoneSmart<span>&gt;</span>
								</Link>
							</li>
						</ul>
						<div className="kids-section bg--outer d-block d-md-none ">
							<ul className="navbar-nav">
								<li className="nav-item bg--outer">
									<Link to={`/kids/`} getProps={isPartiallyActive} className="nav-link link" onClick={(e) => dataLayerClickHandler(e)}>
										For kids<span>&gt;</span>
									</Link>
								</li>
							</ul>
						</div>
					</div>
					<div className="account-section">
						<ul className="navbar-nav">
							
							{(() => {
								if(props.headerStyle!=="beano"){
									return (
										<li className="nav-item" ><AccountPanel pageTitle={pageTitle} /></li>
									)
								}
								else {
									return (
										<li></li>
									)
								}
							})()}
							
							<li className="nav-item bg--outer nav-item-separate d-none d-md-block">
								{(() => {
									if(props.headerStyle !== "beano"){
										return (
											<Link to={`/kids/`} getProps={isPartiallyActive} className="nav-link link notransition" onMouseOver={addHover} onMouseLeave={removeHover}
												onClick={(e) => dataLayerClickHandler(e)}>
												For kids
											</Link>
										)
									}
									else {
										return(
										<Link to={`/register/`} getProps={isPartiallyActive} className="nav-link link notransition" onMouseOver={addHover} onMouseLeave={removeHover}
												data-analytics='{"event":"signUp", "eventCategory":"Beano - Engagement", "eventAction":"CTA Click - Sign up", "eventLabel":"Sign up"}'>
												Sign up
										</Link>
										)
									}
								})()}
								
							</li>
						</ul>
					</div>
				</div>
			</div>
		</nav>
	)
}

export default Navigation
